var app = angular.module("leonardo");

var WorkFlowListDialog = function($scope, ngDialog, WorkFlowService, $filter, FormErrorsService, $timeout) {

  $scope.parent_property = $scope.ngDialogData.property;
  $scope.workflow_id = null;

  WorkFlowService.getlist({disable_pagination: true, by_unit: false, essential:true}).then(function (list) {
    $scope.workflows = list;
  });

  $scope.initTemplates = function(templates) {
    templates = $filter('orderBy')(templates, 'follow_on_level', true);
    angular.forEach(templates, function(value){
      if (value.follow_on){
        angular.forEach(templates, function(parent_value){
          if (parent_value.id == value.follow_on ){
            if (!parent_value.templates) {
              parent_value.templates = [];
            }
            parent_value.templates.push(value);
          }
        });
      }
    });
    var templates_aux = [];
    angular.forEach(templates, function(value) {
      if (!value.follow_on){
        templates_aux.push(value);
      }
    });
    $scope.tree_items = $scope.orderTemplates(templates_aux);
    return $scope.concatTemplates($scope.tree_items, []);
  };

  $scope.orderTemplates = function(templates) {
    var templates_aux = angular.copy(templates);
    angular.forEach(templates_aux, function(template) {
      if(template.templates) {
        template.templates = $scope.orderTemplates(template.templates);
      }
    });
    return $filter('orderBy')(templates_aux, 'name');
  };

  $scope.concatTemplates = function(templates, $results) {
    angular.forEach(templates, function(template) {
      $results.push(template);
      if(template.templates) {
        $results.concat($scope.concatTemplates(template.templates, $results));
      }
    });
    return $results;
  };

  $scope.changeWorkflow = function () {
    if ($scope.workflow_id) {
      WorkFlowService.get($scope.workflow_id).then(function (result) {
        $scope.workflow = result;
      });
    }
  };

  $scope.launchWorkflow = function(){
 

    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var items_ids = [];
    angular.forEach($scope.initTemplates($scope.workflow.templates), function(value){
      items_ids.push(value.id);
    });

    $timeout(function() {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/workflow/launch.html',
        controller: 'LaunchWorkFlowDialog',
        data: {
          workflow: $scope.workflow,
          items: items_ids,
          property: $scope.parent_property,
          context: "Tasks Page"
        }
      }).then(function (){
        // This is intentional do_something blank function
      });
    }, 200);
    $scope.closeThisDialog();
  };

  $scope.$watch('workflow_id', function (newValue, oldValue) {
    if (newValue === oldValue) return;
    $scope.changeWorkflow();
  });

};

app.controller('WorkFlowListDialog', ['$scope', 'ngDialog', 'WorkFlowService', '$filter', 'FormErrorsService', '$timeout',
  WorkFlowListDialog]);
